<div class="cs-list-item" [class.selected]="isSelected$ | async ">
	<ng-container [ngTemplateOutlet]="itemTemplate"
				  [ngTemplateOutletContext]="{$implicit:this}"></ng-container>
</div>


